import * as types from '../constants/ActionTypes'

const initalState = {
  form: {},
}

const master = (state = initalState, action) => {

  switch (action.type) {
    case types.REDUCER_BIZ_HOLIDAY_INIT:

      const form =  {
        year: action.payload.year,
        ...action.payload.list
      }

      return Object.assign({}, state, {
        form 
      })

    case types.REDUCER_BIZ_HOLIDAY_REMOVE_DATE:
    default:
      return state
  }
}

export default master


// WEBPACK FOOTER //
// ./src/reducers/bizHoliday.js